import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campus, Consentement, ConsentementMultiple, Disponibilites, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber } from "components/fields"
import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks"
import { APPOINTMENT, CALL_PHONE, campaigns, consent, defaultValues, getCampus } from "services"
import Cursus from "../components/Cursus"
import Programme from "../components/Programme"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('EART-CONTACT')
  const { submission } = useSubmission()
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...campaigns,
      ...consent,
      campaignId: 'unavailable',
      lead: {
        ...defaultValues,
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, watch } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = {
      ...data.lead,
    }
    const defaultDataLead = {
      Division__c: 'e-artsup',
      IONISSchool__c: 'e-artsup',
      LeadSource: 'Demande de rendez-vous',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      // const leadCreated = await salesforce.createLead(finalLead)

      const subject = data.availabilities.type
      await submission({
          formId: 'CONTACT',
          lead: finalLead,
          subject: subject,
          utmCookieName: '_ionis_user_data' // optionnel
        })
      // const task = {
      //   ActivityDate: new Date(),
      //   OwnerId: leadCreated.OwnerId,
      //   Subject: subject,
      //   WhoId: leadCreated.Id
      // }

      // await salesforce.createTask(task)
      document.location.href=`${url}?ville=${campus}`
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const campus = watch('lead.Campus__c')
  // useEffect
  useSalesforce('BusinessSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <AcademicLevel school="e-artsup" section={false} />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Campus label="Campus souhaité" options={getCampus('e-artsup')} />
        </Grid>
        <Disponibilites  availabilities={[{ label: CALL_PHONE, value: CALL_PHONE }, { label: APPOINTMENT , value: APPOINTMENT }]} eda={false} wantavailabilities={false} />
        <ConsentementMultiple callOptIn />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Contact" school="e-artsup" />
      </Grid>
    </FormProvider>
  )
}

export default Form
